import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatPaginator, MatSnackBar, MatTableDataSource } from '@angular/material';
import { CalendarEventsService } from 'app/main/shared/services/calendarEvent.service';
import { LocalUserService } from 'app/main/shared/services/localUser';
import { HeaderTitleService } from 'app/services/header-title.service';
import * as _ from 'lodash';
import { AddComponent } from './add/add.component';
import { DocketCaseComponent } from './docket-case/docket-case.component';

@Component({
  selector: 'courtDates',
  templateUrl: './court-dates.component.html',
  styleUrls: ['./court-dates.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CourtDatesComponent implements OnInit {

  displayedColumns: string[] = ['date','month','day','del'];
  currentYear: any;

  nextYear: any;

  loading = false;

  courtDates = [];
  currentYearCourtDates = [];
  nextYearCourtDates = [];

  enableCurrentYear = true;

  rows = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('myTable') table: any;
  userId: any;

  dateList = [];

  removeBtn: boolean = true;

  now: any;

  constructor(private calendarEventsService: CalendarEventsService, public dialog: MatDialog, 
    private localUser: LocalUserService, public snackBar: MatSnackBar, private headerService: HeaderTitleService) {
    this.userId = this.localUser.getUserId();
    this.now = new Date();
    this.currentYear = this.now.getFullYear();
    this.nextYear = this.currentYear + 1;
  }
  ngOnInit() {
    this.sendHeaders();
    this.rows.paginator = this.paginator;
    this.getCourtDates();
  }

  sendHeaders(): void {
    this.headerService.sendHeader('gavel', 'Docket')
  }
  getCourtDates() {
    this.loading = true;
    this.calendarEventsService.getCourtDates(this.currentYear)
      .subscribe(data => {
        this.loading = false;
        if(data.length > 0) {
          this.courtDates = data;
        }
        else {
          this.loading = true;
          this.calendarEventsService.getCourtDatesFirstTime()
          .subscribe(data => {
            this.loading = false;
            this.courtDates = data;
          }, error => {
            this.loading = false;
          });
        }
        this.courtDates = _.sortBy(this.courtDates, function(obj) {
          return new Date(obj.date);
        });
        this.courtDates = _.filter(this.courtDates, function(obj) {
          if(new Date(obj.date) < new Date()) {
            obj["state"] = 'Past';
          }
          else {
            obj["state"] = 'Future';
          }
          return obj;
        });
        this.currentYearCourtDates = _.filter(this.courtDates, obj => (obj.status == 'ACTIVE' && obj.year == this.currentYear && obj.state == 'Future'));
        this.rows.data = this.currentYearCourtDates;
        this.nextYearCourtDates = _.filter(this.courtDates, obj => (obj.status == 'ACTIVE' && obj.year == this.nextYear && obj.state == 'Future'));
      }, error => {
        this.loading = false;
      });
  }

  getNextYearDates() {
    this.paginator.pageIndex = 0;
    this.enableCurrentYear = false;
    this.rows.data = this.nextYearCourtDates;
  }

  getCurrentYearDates() {
    this.paginator.pageIndex = 0;
    this.enableCurrentYear = true;
    this.rows.data = this.currentYearCourtDates;
  }

  addDate(date) {
    this.loading = true;
    let obj = {
      date: date,
      by: this.userId
    };
    this.calendarEventsService.addCourtDate(this.currentYear, obj)
      .subscribe(data => {
        this.loading = false;
        this.snackBar.open('Court date added successfully.', null, {
          extraClasses: ['success-snackbar'],
          duration: 5000
        });
        this.getCourtDates();
      }, error => {
        this.loading = false;
        console.log('err: ', error);
      });
  }

  removeDate() {
    this.loading = true;
    let obj = {
      dates: this.dateList.join(';'),
      by: this.userId
    };
    this.calendarEventsService.removeCourtDate(this.currentYear, obj)
      .subscribe(data => {
        this.loading = false;
        this.dateList = [];
        this.removeBtn = true;
        this.snackBar.open('Court dates deleted successfully.', null, {
          extraClasses: ['success-snackbar'],
          duration: 5000
        });
        this.getCourtDates();
      }, error => {
        this.loading = false;
        console.log('err: ', error);
      });
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(AddComponent);
    dialogRef.afterClosed()
      .subscribe(response => {
        if(response.val) {
          this.addDate(response.date);
        }
    });
  }

  selectedDate(checked, value) {
    if(checked) {
      this.dateList.push(value);
    }
    else {
      this.dateList = _.remove(this.dateList, function(date) {
        return (date != value);
      });
    }
    if(this.dateList.length > 0) {
      this.removeBtn = false;
    }
    else {
      this.removeBtn = true;
    }
  }

  getAllCourtDates(checked) {
    if(checked) {
      this.currentYearCourtDates = _.filter(this.courtDates, obj => (obj.status == 'ACTIVE' && obj.year == this.currentYear));
      this.nextYearCourtDates = _.filter(this.courtDates, obj => (obj.status == 'ACTIVE' && obj.year == this.nextYear));
    }
    else {
      this.currentYearCourtDates = _.filter(this.courtDates, obj => (obj.status == 'ACTIVE' && obj.year == this.currentYear && obj.state == 'Future'));
      this.nextYearCourtDates = _.filter(this.courtDates, obj => (obj.status == 'ACTIVE' && obj.year == this.nextYear && obj.state == 'Future'));
    }

    if(this.enableCurrentYear) {
      this.rows.data = this.currentYearCourtDates;
    }
    else {
      this.rows.data = this.nextYearCourtDates;
    }
  }

  openDocket(date) {
    const dialogRef = this.dialog.open(DocketCaseComponent,
      {
        data: {
          date: date
        }
      });
    dialogRef.afterClosed()
      .subscribe(response => {
        if(response) {
          
        }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/court-dates/court-dates.component.ts